import type { ReactNode } from "react";
import { blocosDe, type Bloco, type Trecho } from "../../nucleo/markdown";

/* Desenha a árvore de `nucleo/markdown` como elementos do React. Nada aqui usa
   `dangerouslySetInnerHTML`: o que o autor digitar — inclusive `<script>` e `onerror=` — sai
   como texto escapado. É o que torna a pré-visualização do console segura. */

function trechos(lista: Trecho[]): ReactNode[] {
  return lista.map((trecho, indice) => {
    switch (trecho.tipo) {
      case "texto":
        return trecho.valor;
      case "negrito":
        return <strong key={indice}>{trechos(trecho.filhos)}</strong>;
      case "italico":
        return <em key={indice}>{trechos(trecho.filhos)}</em>;
      case "codigo":
        return <code key={indice}>{trecho.valor}</code>;
      case "link": {
        const externo = /^(https?:|mailto:)/.test(trecho.href);
        return (
          <a
            key={indice}
            href={trecho.href}
            {...(externo ? { target: "_blank", rel: "noopener noreferrer nofollow" } : {})}
          >
            {trechos(trecho.filhos)}
          </a>
        );
      }
    }
  });
}

function bloco(item: Bloco, indice: number): ReactNode {
  switch (item.tipo) {
    case "titulo": {
      const Etiqueta = `h${item.nivel}` as "h2" | "h3" | "h4";
      return <Etiqueta key={indice}>{trechos(item.filhos)}</Etiqueta>;
    }
    case "paragrafo":
      return <p key={indice}>{trechos(item.filhos)}</p>;
    case "lista": {
      const Etiqueta = item.ordenada ? "ol" : "ul";
      return (
        <Etiqueta key={indice}>
          {item.itens.map((filhos, i) => (
            <li key={i}>{trechos(filhos)}</li>
          ))}
        </Etiqueta>
      );
    }
    case "citacao":
      return <blockquote key={indice}>{trechos(item.filhos)}</blockquote>;
    case "codigo":
      return (
        <pre key={indice}>
          <code>{item.valor}</code>
        </pre>
      );
    case "regua":
      return <hr key={indice} />;
  }
}

export function Markdown({ texto, ...resto }: { texto: string; "data-testid"?: string }) {
  return (
    <div className="markdown" {...resto}>
      {blocosDe(texto).map(bloco)}
    </div>
  );
}
